// The 25 animals (grupos): group g holds the dezenas 4g-3 .. 4g, and group 25 ends with 00
export const ANIMALS = [
  '🦤', '🦅', '🫏', '🦋', '🐕', '🐐', '🐏', '🐫', '🐍', '🐇', '🐎', '🐘', '🐓', '🐈', '🐊', '🦁', '🐒', '🐖', '🦚', '🦃',
  '🐂', '🐅', '🐻', '🦌', '🐄',
].map((emoji, i) => {
  const group = i + 1;
  const dezenas = [0, 1, 2, 3].map((k) => (4 * group - 3 + k) % 100);
  return { group, emoji, dezenas };
});

/** Card art of a group (assets/bestiarium/NN.webp); null while it has none, so the emoji stands in */
export const animalArt = (group) => {
  try {
    return require(`../../assets/bestiarium/${String(group).padStart(2, '0')}.webp`);
  } catch (err) {
    return null;
  }
};

export const groupOf = (number) => {
  const d = number % 100;
  return d === 0 ? 25 : Math.floor((d + 3) / 4);
};

export const animalOf = (number) => ANIMALS[groupOf(number) - 1];

export const pad = (value, digits) => String(value).padStart(digits, '0');

// Bet types, as in the contract (`multipliers` index)
export const TYPE = {
  GRUPO: 0,
  DEZENA: 1,
  CENTENA: 2,
  MILHAR: 3,
  GRUPO_1_5: 4,
  DEZENA_1_5: 5,
  CENTENA_1_5: 6,
  MILHAR_1_5: 7,
  DUQUE_GRUPO: 8,
  TERNO_GRUPO: 9,
  DUQUE_DEZENA: 10,
  TERNO_DEZENA: 11,
};

/**
 * What the player picks: the modality (with its cabeça / 1st-5th variants) and how many numbers it takes.
 * `digits` 0 means animals.
 */
export const MODALITIES = [
  { key: 'grupo', head: TYPE.GRUPO, all: TYPE.GRUPO_1_5, count: 1, digits: 0 },
  { key: 'dezena', head: TYPE.DEZENA, all: TYPE.DEZENA_1_5, count: 1, digits: 2 },
  { key: 'centena', head: TYPE.CENTENA, all: TYPE.CENTENA_1_5, count: 1, digits: 3 },
  { key: 'milhar', head: TYPE.MILHAR, all: TYPE.MILHAR_1_5, count: 1, digits: 4 },
  { key: 'duqueGrupo', head: TYPE.DUQUE_GRUPO, count: 2, digits: 0 },
  { key: 'ternoGrupo', head: TYPE.TERNO_GRUPO, count: 3, digits: 0 },
  { key: 'duqueDezena', head: TYPE.DUQUE_DEZENA, count: 2, digits: 2 },
  { key: 'ternoDezena', head: TYPE.TERNO_DEZENA, count: 3, digits: 2 },
];

export const modalityOf = (betType) => MODALITIES.find((m) => m.head === betType || m.all === betType);
export const isAllPrizes = (betType) => betType >= TYPE.GRUPO_1_5 && betType <= TYPE.MILHAR_1_5;

/** Numbers of a stored bet key: the number itself, or the 2-3 sorted values packed by the contract */
export const decodeKey = (betType, key) => {
  if (betType < TYPE.DUQUE_GRUPO) return [key];
  const a = key & 0xff;
  const b = (key >> 8) & 0xff;
  const c = key >> 16;
  return c === 255 ? [a, b] : [a, b, c];
};
